import { Box, styled, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { login, oidcUserManager } from "config/authentication";

import InstallPwa from "./InstallPwa";
import SanaAnimationLoading from "./SanaAnimationLoading";
import useIsMobileView from "hooks/useIsMobileView";
import { useNavigate } from "react-router-dom";

function Welcome() {
  const navigate = useNavigate();
  const isMobileView = useIsMobileView();
  const theme = useTheme();

  const isPwa = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

  useEffect(() => {
    oidcUserManager.getUser().then((user) => {
      if (!user && isPwa) {
        login();
      }
    });
  }, [navigate, isPwa]);

  return (
    <Box sx={{ background: theme.palette.background.default }}>
      {isPwa || !isMobileView ? (
        <SanaAnimationLoading />
      ) : (
        <GridStyle>
          <InstallPwa onClick={login} />{" "}
        </GridStyle>
      )}
    </Box>
  );
}

const GridStyle = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
}));
export default Welcome;

